import { useEffect } from 'react';

import { useCookie } from '../tenant';

const COOKIEYES_COOKIE_NAME = 'cookieyes-consent';
const ANALYTICS_COOKIES_PATTERN = 'analytics:yes';
const ADVERTISEMENT_COOKIES_PATTERN = 'advertisement:yes';
const FUNCTIONAL_COOKIES_PATTERN = 'functional:yes';

const noop = () => {};

const useCookieConsent = ({ onCookiesUpdate = noop } = {}) => {
  const cookieManager = useCookie();

  const isCookieAccepted = pattern => {
    const cookieYesValue = cookieManager.getCookie(COOKIEYES_COOKIE_NAME);

    if (!cookieYesValue) {
      return false;
    }

    return cookieYesValue.includes(pattern);
  };

  useEffect(() => {
    const handleCookieChanged = event => {
      const cookieYesChanged = event.changed.some(
        cookie => cookie.name === COOKIEYES_COOKIE_NAME
      );

      if (cookieYesChanged) {
        onCookiesUpdate();
      }
    };

    if (window.cookieStore) {
      window.cookieStore.addEventListener('change', handleCookieChanged);
    }

    return () => {
      if (window.cookieStore) {
        window.cookieStore.removeEventListener('change', handleCookieChanged);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isAnalyticsCookiesAccepted: () =>
      isCookieAccepted(ANALYTICS_COOKIES_PATTERN),
    isAdvertisementCookiesAccepted: () =>
      isCookieAccepted(ADVERTISEMENT_COOKIES_PATTERN),
    isFunctionalCookiesAccepted: () =>
      isCookieAccepted(FUNCTIONAL_COOKIES_PATTERN)
  };
};

export default useCookieConsent;
